class VariantPagination extends HTMLElement {
    constructor() {
        super()
        this.quantity = parseInt(this.dataset.quantity) || 8
        this.activeFilters = [...document.querySelector('.active-facets').querySelectorAll('facet-remove')]
        this.gridItems = [...document.querySelector('#product-grid').querySelectorAll('.grid__item')]
        this.productCount = document.getElementById('ProductCountDesktop')
        this.visibleItems = 0
        this.setPagination()
        document.addEventListener('facets-changed', () => this.setPagination())
        this.setProductNumber()
    }

    setPagination() {
        window.dispatchEvent(new Event('facets-changed'))
        if (!!this.gridItems.length) {
            this.nPages = 1

            this.gridItems.reduce((acc, item) => {
                if(acc === this.quantity) this.nPages++

                item.dataset.page = this.nPages
                item.style.display = item.dataset.page === "1" ? 'unset' : 'none'

                if(acc === this.quantity) return acc = 1

                return acc + 1
            }, 0)

            if(this.nPages > 1) {
                this.renderPagination()
                this.setPaginationFunctions()
            }
        }
    }

    setProductNumber() {
        this.visibleItems = this.gridItems.filter(x => x.style.display != 'none')?.length
        if(this.visibleItems && this.productCount) this.productCount.innerHTML = this.visibleItems == 1 ? `${this.visibleItems} producto` : `${this.visibleItems} productos`
    }

    renderPagination() {
        let oldPagination = document.querySelector('.pagination-wrapper')
        if(oldPagination) oldPagination.parentElement.removeChild(oldPagination)

        let paginationTemplate = document.createElement("div")
        paginationTemplate.classList.add("pagination-wrapper")

        paginationTemplate.innerHTML = `
            <nav class="pagination" role="navigation" aria-label="Paginación">
                <ul class="pagination__list list-unstyled" role="list">

                </ul>
            </nav>
        `

        let paginationList = paginationTemplate.querySelector('.pagination__list')
        paginationList.innerHTML += `
            <button class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce infinite-horizontal" aria-label="Pagina anterior">
                <svg id="arrow-left" width="22px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.155 20.779">
                <g id="arrow-right" transform="translate(1 1.406)">
                  <path id="Trazado_2" data-name="Trazado 2" d="M20.218,6.75,27.4,15.734l-7.187,8.984M27.4,15.734H2.25" transform="translate(-2.25 -6.75)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                </g>
                </svg>
            </button>
        `

        for (let i=1; i<=this.nPages; i++) {
            paginationList.innerHTML += `
                <li>
                    <button class="pagination__item">${i}</button>
                </li>
            `
        }

        paginationList.innerHTML += `
            <button class="pagination__item pagination__item--next pagination__item-arrow link motion-reduce infinite-horizontal" aria-label="Página siguiente">
                <svg id="arrow-right" width="22px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.155 20.779">
                  <g id="arrow-right" transform="translate(1 1.406)">
                    <path id="Trazado_2" data-name="Trazado 2" d="M20.218,6.75,27.4,15.734l-7.187,8.984M27.4,15.734H2.25" transform="translate(-2.25 -6.75)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                  </g>
                </svg>
            </button>
        `

        this.paginationItems = [...paginationList.querySelectorAll(".pagination__item")]
        this.paginationItems[1].classList.add('pagination__item--current')
        this.renderArrows()

        this.appendChild(paginationTemplate)
    }

    setPaginationFunctions() {
        if(!!!this.paginationItems.length) return

        this.paginationItems.forEach(item => {
            item.addEventListener("click", () => {
                item.classList.contains('pagination__item-arrow')
                ? item.classList.contains('pagination__item--next') ? this.renderNext() : this.renderPrev()
                : this.renderSpecific(item)
            })
        })
    }

    renderNext() {
        let pageCurrent = parseInt(this.paginationItems.find(item => item.classList.contains('pagination__item--current')).innerHTML)
        this.paginationItems.find(item => item.innerHTML === `${pageCurrent+1}`).click()
    }

    renderPrev() {
        let pageCurrent = parseInt(this.paginationItems.find(item => item.classList.contains('pagination__item--current')).innerHTML)
        this.paginationItems.find(item => item.innerHTML === `${pageCurrent-1}`).click()
    }

    renderSpecific(item) {
        this.gridItems.forEach(gridItem => {
            gridItem.style.display = gridItem.dataset.page === item.innerHTML ?  'unset' : 'none'
        })
        this.paginationItems.forEach(item2 => item2.classList.remove('pagination__item--current'))
        item.classList.add('pagination__item--current')

        window.scroll({
            top: 350
        })

        this.renderArrows()
    }

    renderArrows() {
        let pageCurrent = this.paginationItems.find(item => item.classList.contains('pagination__item--current')).innerHTML
        let prevBtn = this.paginationItems.find(item => item.classList.contains('pagination__item--prev'))
        let nextBtn = this.paginationItems.find(item => item.classList.contains('pagination__item--next'))
        switch(pageCurrent) {
            case "1":
                prevBtn.style.display = 'none'
                nextBtn.style.display = 'unset'
                break
            case `${this.nPages}`:
                prevBtn.style.display = 'unset'
                nextBtn.style.display = 'none'
                break
            default:
                prevBtn.style.display = 'unset'
                nextBtn.style.display = 'unset'
                break;
        }

        this.setProductNumber()
    }
}
customElements.define('variant-pagination', VariantPagination)
